module.exports = __webpack_public_path__ + "error.svg";


//////////////////
// WEBPACK FOOTER
// ./~/blueimp-gallery/img/error.svg
// module id = 1191
// module chunks = 6